import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import ddt from '@wix/da-ddt';
import { actions as userActions } from '../../redux/users';
import { publishCommentSuccess as publishCommentSuccessNew } from '../../CommentEditor/redux/actionCreators';
import { reportComment, likeComment, unlikeComment, featureComment, requestSuccess, requestFailure, unfeatureComment, hideComment, unhideComment, updateCommentBadges } from './actionCreators';
import { reduxKey } from './constants';
const actionHandler = handleActions({
    [requestSuccess.toString()]: (state, action)=>{
        return state;
    },
    [requestFailure.toString()]: (state, action)=>{
        if (!action.payload) {
            return state;
        }
        switch(action.payload.actionType){
            case featureComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isFeatured: false
                });
            case unfeatureComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isFeatured: true
                });
            case likeComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isLiked: false,
                    likes: (state.likes || 0) - 1
                });
            case unlikeComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isLiked: true,
                    likes: (state.likes || 0) + 1
                });
            case hideComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isHidden: false
                });
            case unhideComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isHidden: true
                });
            case reportComment.toString():
                return _object_spread_props(_object_spread({}, state), {
                    isSpam: false
                });
            case userActions.blockUserFail.toString():
                // blocking user does nothing visually to the page, yet.
                return state;
            default:
                return state;
        }
    },
    [featureComment.toString()]: (comment, action)=>{
        return _object_spread_props(_object_spread({}, comment), {
            isFeatured: true
        });
    },
    [unfeatureComment.toString()]: (comment, action)=>{
        return _object_spread_props(_object_spread({}, comment), {
            isFeatured: false
        });
    },
    [likeComment.toString()]: (comment, action)=>{
        if (!action.payload) {
            return comment;
        }
        const likes = comment && comment.likes || action.payload.comment.likes || 0;
        return _object_spread_props(_object_spread({}, comment), {
            isLiked: true,
            likes: likes + 1
        });
    },
    [updateCommentBadges.toString()]: (comment, action)=>{
        const { payload } = action;
        if (!payload || !payload.comment) {
            return comment;
        }
        var _payload_allBadges;
        return _object_spread_props(_object_spread({}, action.payload.comment), {
            awardedBadges: (_payload_allBadges = payload.allBadges) !== null && _payload_allBadges !== void 0 ? _payload_allBadges : []
        });
    },
    [unlikeComment.toString()]: (comment, action)=>{
        if (!action.payload) {
            return comment;
        }
        const likes = comment && comment.likes || action.payload.comment.likes || 0;
        return _object_spread_props(_object_spread({}, comment), {
            isLiked: false,
            likes: likes - 1
        });
    },
    [hideComment.toString()]: (comment, action)=>{
        return _object_spread_props(_object_spread({}, comment), {
            isHidden: true
        });
    },
    [unhideComment.toString()]: (comment, action)=>{
        return _object_spread_props(_object_spread({}, comment), {
            isHidden: false
        });
    },
    [reportComment.toString()]: (comment, action)=>{
        return _object_spread_props(_object_spread({}, comment), {
            isSpam: true
        });
    },
    [publishCommentSuccessNew.toString()]: (comment, action)=>{
        return _object_spread({}, action.payload.comment);
    }
}, {});
const reducers = {
    [reduxKey]: (state = {}, action)=>{
        const { type, payload } = action;
        if (!payload || !payload.comment || !payload.comment.commentId) {
            // ddt.log('comments', 'ineligible event data: no commentid', action);
            return state;
        }
        ddt.log('comments', `EVENT: ${type}`);
        const stateKey = payload.comment.commentId;
        const comment = state[stateKey] || payload.comment;
        const newState = actionHandler(comment, action);
        return _object_spread_props(_object_spread({}, state), {
            [stateKey]: newState
        });
    }
};
export default reducers;

//# sourceMappingURL=reducers.js.map